// extracted by mini-css-extract-plugin
export default {"resend":"fQ8tQMcGT4Tcjj7rhyqR"};